import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import Constants from '../../../definitions/constants';

import TextBox from '../common/inputs/textBox';
import CheckBox from '../common/inputs/checkBox';
import Button from '../common/inputs/button';
import ErrorFeedback from '../common/feedback/errorFeedback';
import Logo from '../../../../public/images/logo_flexpay_login.png';
import LogoMain from '../../../../public/images/logo_dashboard.png';

const LoginForm = props => {
  const {
    errors,
    handleLogin,
    handleOnChange,
    handleShowResetPasswordPopup,
    status,
    loading,
    formData
  } = props;
  return (
    <div className="login_container">
      <div className='login_top_logo'>
         <img src={Logo} height="100%" alt={useIntl().formatMessage({ id: "common.companyName" })}/>
      </div>
      <div className="login_content">
        <div className="login_content_branding">
          <div className="login_content_branding_top">
            <i className="fas fa-check-circle"/>
          </div>
          <div className="login_content_branding_center">
            <h1><FormattedMessage id="login.brandingTitle"/></h1>
          </div>
          <div className="login_content_branding_bottom">
            <h3><FormattedMessage id="login.brandingDescription"/></h3>
          </div>
        </div>
        <div className="login_content_form">
          <div className="login_content_form_title">
            <h1><img src={LogoMain} height="100%" alt={intl.formatMessage({ id: "common.companyName" })}/></h1>
            <h3><FormattedMessage id="login.login"/></h3>
          </div>
          <div className="login_content_form_inputs">
            <form>
              <TextBox
                styleType={Constants.interface.inputs.styleType.STANDARD}
                type={Constants.interface.inputs.type.EMAIL}
                id="email"
                value={formData.email}
                onChange={handleOnChange}
                onKeyEnter={handleLogin}
                labelLocale={<FormattedMessage id="common.email"/>}
                autoComplete="true"
              />
              {(!formData.is_sso) && (
                <TextBox
                  styleType={Constants.interface.inputs.styleType.STANDARD}
                  type={Constants.interface.inputs.type.PASSWORD}
                  id="password"
                  value={formData.password}
                  onChange={handleOnChange}
                  onKeyEnter={handleLogin}
                  labelLocale={<FormattedMessage id="login.password"/>}
                />
              )}
              <div className="row_fields">
                {(!formData.is_sso) && (
                  <CheckBox
                    className="login_content_form_inputs_remember_me"
                    id="rememberMe"
                    value={formData.rememberMe}
                    onChange={handleOnChange}
                    labelLocale={<FormattedMessage id="login.rememberMe"/>}
                  />
                )}
                <CheckBox
                  className="login_content_form_inputs_is_sso"
                  id="is_sso"
                  value={formData.is_sso}
                  onChange={handleOnChange}
                  labelLocale={<FormattedMessage id="login.is_sso"/>}
                />
              </div>
            </form>
            <ErrorFeedback
              status={status}
              optionalStatusErrors={{
                "401": <FormattedMessage id="login.errors.invalidLoginData"/>
              }}
            />
          </div>
          <div className="login_content_form_button">
            <Button
              disabled={loading}
              loading={loading}
              onClick={handleLogin}
              labelLocale={<FormattedMessage id="login.loginAction"/>}
            />
          </div>
          <div className="login_content_form_forgot">
            <a 
              className="login_content_form_forgot_link"
              onClick={handleShowResetPasswordPopup}
            >
              <FormattedMessage id="login.forgotYourPassword"/>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;



// WEBPACK FOOTER //
// ./source/client/components/login/loginForm.jsx